import { render, staticRenderFns } from "./BaseAddressPicker.vue?vue&type=template&id=2bbb5b23&"
import script from "./BaseAddressPicker.vue?vue&type=script&lang=ts&"
export * from "./BaseAddressPicker.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAddressPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports